/* Sovereign Abundance PDP v2 (spirad.com, Elixir layout): the mockup's behaviour
   (gallery with swipe, tiers shared by the buy box, the sticky bar and the packages
   block, sticky on scroll) plus the store: the selected tier puts 1, 3 or 5 of the
   product's one variant in the cart (the store's automatic B2G1 / B3G2 discounts make
   1 or 2 free), then Elixir's cart drawer opens; delivery date computed live.
   Edit the mockup first, then this file. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* gallery */
  var slides = $$('#gmain .slide'), thumbs = $$('#thumbs button'), cur = 0;
  function show(i) {
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); });
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === cur); });
    var gi = $('#gidx'); if (gi) gi.textContent = cur + 1;
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
  $$('.g-arrow').forEach(function (b) { b.addEventListener('click', function () { show(cur + +b.dataset.dir); }); });
  var gm = $('#gmain'), x0 = null;
  if (gm) {
    gm.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gm.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
  }

  /* tiers: buy box, sticky segment and packages block share one selection */
  var tiers = $$('.tier'), sel = null;
  function pick(k) {
    var t = tiers.filter(function (x) { return x.dataset.k == k; })[0]; if (!t) return;
    sel = t;
    tiers.forEach(function (x) { x.classList.toggle('sel', x === t); var i = $('input', x); if (i) i.checked = x === t; });
    $$('.js-price').forEach(function (e) { e.textContent = t.dataset.price; });
    $$('#seg button').forEach(function (b) { b.classList.toggle('on', b.dataset.k == k); });
    $$('#pk .pkc').forEach(function (c) { c.classList.toggle('sel', c.dataset.k == k); });
    /* the gifts of the selected tier are lit, the others dimmed (offer-stack.md §4) */
    $$('#gifts li').forEach(function (l) { l.classList.toggle('off', +l.dataset.min > +k); });
  }
  tiers.forEach(function (t) { t.addEventListener('click', function () { pick(t.dataset.k); }); });
  $$('#seg button').forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.k); }); });
  $$('#pk .pkc').forEach(function (c) { c.addEventListener('click', function () { pick(c.dataset.k); }); });
  /* ?tier=1|2|3 or ?qty=1|3|5 preselects a tier (links from the pre-sell pages) */
  var q = new URLSearchParams(location.search), tq = q.get('tier'), qq = q.get('qty');
  var t0 = tiers.filter(function (t) { return (tq && t.dataset.k === tq) || (qq && t.dataset.qty === qq); })[0] || tiers.filter(function (t) { return t.classList.contains('sel'); })[0];
  if (t0) pick(t0.dataset.k);

  /* add to cart, then Elixir's drawer (or the cart page) */
  var cta = $('#buy-cta');
  if (cta) cta.addEventListener('click', function (e) {
    e.preventDefault();
    if (!sel || !sel.dataset.variant) return;
    var id = +sel.dataset.variant, qty = +sel.dataset.qty || 1;
    cta.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw r; })
      .then(function () {
        var d = document.querySelector('cart-drawer');
        if (d && d.refreshCartDrawer) return d.refreshCartDrawer().then(function () { if (d.classList.contains('is-empty')) d.classList.remove('is-empty'); d.open && d.open(cta); });
        location.href = '/cart';
      })
      .catch(function () { location.href = '/cart/add?id=' + id + '&quantity=' + qty; })
      .then(function () { cta.removeAttribute('aria-busy'); });
  });

  /* sticky: on once the buy-box CTA has scrolled above the viewport */
  var sticky = $('#sticky');
  function st() { if (sticky && cta) sticky.classList.toggle('on', cta.getBoundingClientRect().bottom < 0); }
  addEventListener('scroll', st, { passive: true }); addEventListener('resize', st); st();

  /* delivery date: today + N business days */
  var buy = $('#s1');
  var door = new Date(), left = buy ? +buy.dataset.doorDays || 7 : 7;
  while (left > 0) { door.setDate(door.getDate() + 1); if (door.getDay() % 6) left--; }
  $$('.js-door').forEach(function (e) { e.textContent = DAY[door.getDay()] + ', ' + MON[door.getMonth()] + ' ' + door.getDate(); });
})();

/* FALL25 and the launch gifts end on the Sunday of the current week in New York (today on a Sunday): rolling,
   never out of date (William, 2026-10-29). .js-deadline "Sunday, November 1" · .js-deadline-short "Sun, Nov 1" ·
   .js-deadline-md "Nov 1"; the text written in the page is the fallback without JavaScript. */
(function () {
  var els = document.querySelectorAll('.js-deadline, .js-deadline-short, .js-deadline-md');
  if (!els.length) return;
  var d;
  try { d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { d = new Date(); }
  d.setDate(d.getDate() + (7 - d.getDay()) % 7);
  var D = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var day = D[d.getDay()], mon = M[d.getMonth()], n = d.getDate();
  els.forEach(function (e) {
    e.textContent = e.classList.contains('js-deadline-md') ? mon.slice(0, 3) + ' ' + n
      : e.classList.contains('js-deadline-short') ? day.slice(0, 3) + ', ' + mon.slice(0, 3) + ' ' + n
      : day + ', ' + mon + ' ' + n;
  });
})();
